import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from 'react';
import { motion } from 'framer-motion';
import { mergeClasses } from '@/utils/style';
interface Props {
  icon?: JSX.Element;
  onClick?: () => void;
  isActive?: boolean;
}
function SheetItem(props) {
  const $ = _c(9);
  const {
    icon,
    onClick,
    children
  } = props;
  const t0 = props.isActive === true;
  let t1;
  if ($[0] !== t0) {
    t1 = mergeClasses("flex w-full bg-transparent px-6 py-3 text-left transition-all duration-100 ease-in-out", {
      "bg-gray-50 font-semibold": t0
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon) {
    t2 = icon && <div className="h-6 w-6 text-black">{icon}</div>;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== onClick || $[6] !== t1 || $[7] !== t2) {
    t3 = <motion.button onClick={onClick} className={t1}>{t2}{children}</motion.button>;
    $[4] = children;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export default SheetItem;